module.exports = __webpack_public_path__ + "img/smartStone.e3759f62.png";